exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".PostSubtitle__link___G6bYj {\n\ttext-decoration: none;\n\tcolor: inherit;\n    font-weight: bold;\n}\n", ""]);

// exports
exports.locals = {
	"link": "PostSubtitle__link___G6bYj"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/Item/PostSubtitle.icss
// module id = 1312
// module chunks = 0